import { JobImageType, JobPhase } from './jobs';

export interface InsightsData {
  tasks: TaskDetail[];
  startDate: string | Date;
  endDate: string | Date;
  selectedDrivers?: number[];
  orgId: number;
}

export interface InsightsParams {
  orgId?: number;
  startDate?: Date;
  endDate?: Date;
  selectedDrivers?: number[];
}

export interface TransformedTask {
  id: number;
  appointment_id: string;
  agent_name: string;
  phase: JobPhase;
  feedback_rating: number;
  wait_time: string;
  time_on_site: string;
  distance_traveled: number;
  promised_time: string;
  completed_time: string;
  task: TaskDetail;
}

export interface TaskDetail {
  id: number;
  task_id: number;
  task_description: string;
  foreign_id: string;
  org_id: number;
  org_name: string;
  org_tags: string[];
  agent_id: number;
  agent_name: string;
  agent_foreign_id: string;
  agent_tags: string[];
  task_created_time: number;
  dest_local_timezone: string;
  dest_name: string;
  dest_lat: number;
  dest_lng: number;
  last_phase: string;
  completed_time: number;
  due_time: number;
  session_id: number;
  session_assigned_time: number;
  session_start_time: number;
  session_completed_time: number;
  session_rank: number;
  recipients_notified: number;
  feedback_comment: string;
  feedback_rating: number;
  feedback_time_posted: number;
  agent_logged_in: boolean;
  phases_reached: string[];
  unique_views: number;
  phase_views: any;
  arrival_method: string;
  travel_modes: string[];
  time_started: number;
  time_arrived: number;
  quasi_time: number;
  time_live: number;
  avatar: string;
  images: TaskImage[];
  location_shared: boolean;
  distance_traveled: number;
  metadata: Array<{
    pid: number;
    n: string;
    v: string;
  }>;
  recipients: Array<{
    notify?: boolean;
    name?: string;
    address: string;
  }>
}

interface TaskImage {
  url: string;
  agent_id: number;
  created: number;
  lng: number;
  lat: number;
  type: JobImageType;
}


export enum WidgetType {
  Value,
  Rating,
  Percent
}

export enum WidgetName {
  Completed = 'completed',
  Canceled = 'canceled',
  AvgRating = 'avg_rating',
  OnTimeDeliveries = 'on_time_deliveries',
  Feedback = 'feedback',
  FeedbackComment = 'feedback_comment',
  FeedbackRating = 'feedback_rating'
}

export interface WidgetConfig {
  title: string,
  field: WidgetName,
  type: WidgetType,
  completedTasksScreen?: boolean,
}
